import type { FaireProductEntity } from "../../entity_types/product";

export const p_3tbdvzr2bd: FaireProductEntity = {
  token: "p_3tbdvzr2bd",
  type: "product",
  name: "Harvest Basket Candle Tester",
  brandToken: "b_jx5r7yrney",
  brandName: "Loam Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/944d8fe0a6fa89fa379c07d0e7321dc6277e01560dab81a1d39f28ea9fefd27b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de49dd4332841b5e13df12a41f86dff229884037eee89e54f3095f1fc16ab806.jpeg",
    "https://cdn.faire.com/fastly/92024707ebbabe124ecf098021043cacd365e3b860e8d199fc0bfbc68d86c963.jpeg",
    "https://cdn.faire.com/fastly/9e73d7f6ce7bd1871f47798f9f79fc999512cd12e2b8f9913fd0c5cd1098f968.jpeg",
  ],
  priceDollars: 9,
  description:
    "This is a full-size tester candle. Please limit your order to 1 tester per case pack.\n\nScent notes: hay, tobacco, vetiver, and patchouli.\n\nFor when the long days of summer come to an end and plant production begins to wind down. Warm, musky, and earthy, Harvest Basket is the scent to celebrate the growing season’s gifts.\n\nThe vibe: leathery, earthy, deep, smoky.\n\nEvery candle is crafted in small batches with coconut soy wax and 100% cotton wicks. Loam candles are always paraben, paraffin, petroleum, and phthalate-free.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:10.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
